module.exports = __webpack_public_path__ + "static/media/list-current.00482350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/list-current.jpg
// module id = 652
// module chunks = 0